/**
 * Style d'un texte lu par les lecteurs d'ecran et invisible a l'ecran : la
 * precision qu'un nombre seul ne porte pas (« 2 à traiter »), une annonce de
 * region vivante. Les dimensions sont des chaines : dans `sx`, `width: 1`
 * voudrait dire 100 %.
 */
export const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
} as const;
